export enum PurchaseOrderEmail {
  CreatePurchaseOrderVendorRelease = 'create_purchase_order_vr',
  UpdatePurchaseOrderVendorRelease = 'update_purchase_order_vr',
  CreatePurchaseOrderRedeliveryToVendor = 'create_purchase_order_rd_to_vendor',
  CreatePurchaseOrderRedeliveryToDepot = 'create_purchase_order_rd_to_depot',
  UpdatePurchaseOrderRedeliveryToVendor = 'update_purchase_order_rd_to_vendor',
  UpdatePurchaseOrderRedeliveryToDepot = 'update_purchase_order_rd_to_depot',
}
